module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VU-e39b5bae82561884310d899ae18f6cc5.png";